// Public address of the live site, for canonical links and social preview images.
export const SITE_URL = 'https://jbrdeliveryllc.com';

// Main phone number, for call buttons
export const PHONE_NUMBER = '9202558952';
export const PHONE_DISPLAY = '(920) 255-8952';

// Number for "Text us photos" buttons. Leave empty until Diego confirms it can receive texts.
export const TEXT_NUMBER: string = '';
